exports.en = {
  CHART_RANGE: {
    LABEL: 'Show data for the last |||| Show data for the last',
    LABEL_ALL: 'Show data',
    LABEL_FREE: 'Show data within',
    FROM: 'from',
    TO: 'to',
    WEEKS: 'week |||| weeks',
    MONTHS: 'month |||| months',
    YEARS: 'year |||| years',
    ALL: 'since inception',
    FREE: 'free range'
  }
}
